import { getLink } from "../../../NavUtils";

// full page path
export const getNavOrgMenuBuilder = (plannedMenuId: string) => `/org/menu-builder/${plannedMenuId}`;

// full child paths
export const getNavOrgMenuBuilderLink = (plannedMenuId: string, plannedMenuName: string) =>
  getLink(plannedMenuName, getNavOrgMenuBuilder(plannedMenuId));
